module.exports = __webpack_public_path__ + "static/media/icon-piece5-5.3e7edf12.png";